import { historyApi as api } from './emptyHistoryApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    autoplayControllerShowAutoplaysHistory: build.query<
      AutoplayControllerShowAutoplaysHistoryApiResponse,
      AutoplayControllerShowAutoplaysHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/history-api/autoplay/last`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    historyControllerGetGameHistory: build.query<
      HistoryControllerGetGameHistoryApiResponse,
      HistoryControllerGetGameHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/history-api/game/history`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    historyControllerGetLotteryGamesFinishedStates: build.query<
      HistoryControllerGetLotteryGamesFinishedStatesApiResponse,
      HistoryControllerGetLotteryGamesFinishedStatesApiArg
    >({
      query: (queryArg) => ({
        url: `/history-api/game/history/lottery-games-finished-states`,
        params: { gameRoomIds: queryArg.gameRoomIds },
      }),
    }),
    healthControllerIsReady: build.query<
      HealthControllerIsReadyApiResponse,
      HealthControllerIsReadyApiArg
    >({
      query: () => ({ url: `/history-api/health` }),
    }),
    metricsControllerGetMetrics: build.query<
      MetricsControllerGetMetricsApiResponse,
      MetricsControllerGetMetricsApiArg
    >({
      query: () => ({ url: `/history-api/metrics` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as historyApi };
export type AutoplayControllerShowAutoplaysHistoryApiResponse =
  /** status 200  */ AutoplayOutputDto;
export type AutoplayControllerShowAutoplaysHistoryApiArg = {
  take?: number;
  skip?: number;
};
export type HistoryControllerGetGameHistoryApiResponse =
  /** status 200  */ GameHistoryDto;
export type HistoryControllerGetGameHistoryApiArg = {
  take?: number;
  skip?: number;
};
export type HistoryControllerGetLotteryGamesFinishedStatesApiResponse =
  /** status 200  */ LotteryGamesFinishedStatesDto;
export type HistoryControllerGetLotteryGamesFinishedStatesApiArg = {
  /** Game room ids separated by comma */
  gameRoomIds: string[];
};
export type HealthControllerIsReadyApiResponse = unknown;
export type HealthControllerIsReadyApiArg = void;
export type MetricsControllerGetMetricsApiResponse = unknown;
export type MetricsControllerGetMetricsApiArg = void;
export type RevealedSeedDto = {
  hash: string;
  localSeed: string;
};
export type GameHistoryDiceMetadataDto = {
  max: number;
  winNumber: number;
};
export type LotteryJackpotHistoryWinnerDto = {
  numJackpotTickets: number;
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
};
export type LotteryHistoryWinnerDto = {
  winNumber: number;
  winner: number;
  prize: string;
  jackpots: LotteryJackpotHistoryWinnerDto[];
};
export type WinnerForMatchesPrizeDto = {
  orderedMatches: string;
  unorderedMatches: string;
  totalForMatches: string;
};
export type WinnerForMatchesDto = {
  player: number;
  prize: WinnerForMatchesPrizeDto;
};
export type SuperTicketStateDto = {
  superTicketType:
    | 'TICKET_5'
    | 'TICKET_10'
    | 'TICKET_150'
    | 'TICKET_240'
    | 'TICKET_980'
    | 'TICKET_2000'
    | 'METALLIC_IRON_160'
    | 'METALLIC_BRONZE_360'
    | 'METALLIC_SILVER_560';
  multiplier: number;
  /** На какие места действует умножение на muliplier */
  multiplyPlaces: number[];
};
export type GameHistoryLotteryMetadataDto = {
  winNumbers: number[];
  pickedNumbers: number[];
  turnType: 'all' | 'turn';
  winners: LotteryHistoryWinnerDto[];
  winnerForMatches?: WinnerForMatchesDto;
  superTicketState?: SuperTicketStateDto;
  gameNumber?: string;
};
export type GameHistoryRecordDto = {
  seed: RevealedSeedDto;
  bet: string;
  isWin: boolean;
  prizeMoney?: string;
  gameType: 'dice' | 'lottery';
  metadata: GameHistoryDiceMetadataDto | GameHistoryLotteryMetadataDto;
  playDate: string;
};
export type AutoplayOutputDto = {
  autoplayUuid: string;
  bet: string;
  count: number;
  records: GameHistoryRecordDto[];
  status: 'insufficient_balance' | 'all_games_played' | 'in_progress' | 'stopped';
  totalWinnings: string;
};
export type GameHistoryDto = {
  count: number;
  records: GameHistoryRecordDto[];
};
export type JackpotTicketCounterDto = {
  count: number;
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  drawAmount?: string;
};
export type WinnerPrizeDto = {
  money: string;
  jackpots: JackpotTicketCounterDto[];
};
export type WinnerDto = {
  prize?: WinnerPrizeDto;
  winNumber: number;
  player: number;
};
export type LotteryFinishedStateDto = {
  gameRoomId?: string;
  autoFinish?: boolean;
  seed: RevealedSeedDto;
  winners: WinnerDto[];
  winnerForMatches?: WinnerForMatchesDto;
  superTicketState?: SuperTicketStateDto;
  gameNumber?: string;
};
export type LotteryGamesFinishedStatesDto = {
  records: LotteryFinishedStateDto[];
};
export const {
  useAutoplayControllerShowAutoplaysHistoryQuery,
  useLazyAutoplayControllerShowAutoplaysHistoryQuery,
  useHistoryControllerGetGameHistoryQuery,
  useLazyHistoryControllerGetGameHistoryQuery,
  useHistoryControllerGetLotteryGamesFinishedStatesQuery,
  useLazyHistoryControllerGetLotteryGamesFinishedStatesQuery,
  useHealthControllerIsReadyQuery,
  useLazyHealthControllerIsReadyQuery,
  useMetricsControllerGetMetricsQuery,
  useLazyMetricsControllerGetMetricsQuery,
} = injectedRtkApi;
